import React, { useEffect, useState, useCallback, useMemo } from "react";

// ==== DATA ====
const GALLERY = [
  {
    categories: ["React", "Tailwind"],
    images: [
      "/images/projects/1.png",
      "/images/projects/1-2.png",
      "/images/projects/1-3.png",
      "/images/projects/1-4.png",
      "/images/projects/1-5.png",
    ],
    thumb: "/images/projects/1.png",
    link: "https://avinto.my.id",
    title: "Portfolio v2",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/2.png", "/images/projects/2-2.png", "/images/projects/2-3.png", "/images/projects/2-4.png"],
    thumb: "/images/projects/2.png",
    link: "https://aipt.uinsu.ac.id",
    title: "AIPT UINSU",
  },
  {
    categories: ["Wordpress"],
    images: ["/images/projects/3.png", "/images/projects/3-2.png", "/images/projects/3-3.png", "/images/projects/3-4.png"],
    thumb: "/images/projects/3.png",
    link: "https://uinsu.ac.id",
    title: "UIN SU Main",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/4.png"],
    thumb: "/images/projects/4.png",
    link: "https://tracerstudy.uinsu.ac.id/",
    title: "Tracer Study",
  },
  {
    categories: ["Laravel"],
    images: ["/images/projects/5.png"],
    thumb: "/images/projects/5.png",
    link: "https://tracerstudy.uinsu.ac.id/career",
    title: "Tracer Career",
  },
  {
    categories: ["Laravel", "Bootstrap", "Flutter"],
    images: [
      "/images/projects/6.png",
      "/images/projects/6-2.png",
      "/images/projects/6-3.png",
      "/images/projects/6-4.png",
      "/images/projects/6-5.png",
    ],
    thumb: "/images/projects/6.png",
    link: "https://repository1.uinsu.ac.id",
    title: "Repository",
  },
   {
    categories: ["Laravel", "Bootstrap"],
    images: [
      "/images/projects/22.png",
      "/images/projects/22-2.png",
      "/images/projects/22-3.png",
      "/images/projects/22-4.png",
      "/images/projects/22-5.png",
    ],
    thumb: "/images/projects/22.png",
    link: "https://aps.uinsu.ac.id",
    title: "APS UINSU",
  },
  {
    categories: ["Bootstrap"],
    images: [
      "/images/projects/7.png",
      "/images/projects/7-2.png",
      "/images/projects/7-3.png",
      "/images/projects/7-4.png",
      "/images/projects/7-5.png",
    ],
    thumb: "/images/projects/7.png",
    link: "https://kkn16uinsu.github.io/",
    title: "KKN 16",
  },
  {
    categories: ["Bootstrap"],
    images: ["/images/projects/8.png", "/images/projects/8-2.png", "/images/projects/8-3.png", "/images/projects/8-4.png"],
    thumb: "/images/projects/8.png",
    link: "https://tanipematangkuing.github.io/",
    title: "Tani Pematangkuing",
  },
  {
    categories: ["Bootstrap"],
    images: ["/images/projects/9.png", "/images/projects/9-2.png"],
    thumb: "/images/projects/9.png",
    link: "https://alvinalvito.github.io/novel/",
    title: "Novel Reader",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/10.png", "/images/projects/10-2.png", "/images/projects/10-3.png"],
    thumb: "/images/projects/10.png",
    link: "http://jurusan.avinto.my.id/",
    title: "Jurusan",
  },
  {
    categories: ["React", "Tailwind"],
    images: ["/images/projects/11.png", "/images/projects/11-2.png", "/images/projects/11-3.png"],
    thumb: "/images/projects/11.png",
    link: "https://skripsi.avinto.my.id/",
    title: "Skripsi Tools",
  },
  {
    categories: ["React", "Tailwind", "Flutter"],
    images: ["/images/projects/12.png", "/images/projects/12-2.png", "/images/projects/12-3.png", "/images/projects/12-4.png"],
    thumb: "/images/projects/12.png",
    link: "https://myuinsu.avinto.my.id/",
    title: "MyUINSU",
  },
  {
    categories: ["React", "Tailwind", "Express", "Flutter"],
    images: [
      "/images/projects/13.png",
      "/images/projects/13-2.png",
      "/images/projects/13-3.png",
      "/images/projects/13-4.png",
      "/images/projects/13-5.png",
      "/images/projects/13-6.png",
      "/images/projects/13-7.png",
      "/images/projects/13-8.png",
      "/images/projects/13-9.png",
      "/images/projects/13-10.png",
    ],
    thumb: "/images/projects/13-2.png",
    link: "https://sibima.uinsu.ac.id",
    title: "SiBima",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/14.png", "/images/projects/14-2.png", "/images/projects/14-3.png", "/images/projects/14-4.png"],
    thumb: "/images/projects/14.png",
    link: "https://sikerma.uinsu.ac.id",
    title: "SiKerma",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/15.png", "/images/projects/15-2.png"],
    thumb: "/images/projects/15.png",
    link: "http://upahkerja.avinto.my.id/",
    title: "Upah Kerja",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/16.png", "/images/projects/16-2.png", "/images/projects/16-3.png"],
    thumb: "/images/projects/16.png",
    link: "http://sembako.avinto.my.id",
    title: "Sembako",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/17.png", "/images/projects/17-2.png", "/images/projects/17-3.png"],
    thumb: "/images/projects/17.png",
    link: "http://penyakit.avinto.my.id/",
    title: "Diagnosa Penyakit",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/18.png", "/images/projects/18-2.png", "/images/projects/18-3.png"],
    thumb: "/images/projects/18.png",
    link: "http://biology.avinto.my.id/",
    title: "Biology LMS",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/19.png", "/images/projects/19-2.png", "/images/projects/19-3.png", "/images/projects/19-4.png"],
    thumb: "/images/projects/19.png",
    link: "http://saham.avinto.my.id/",
    title: "Rekomendasi Saham",
  },
  {
    categories: ["Laravel", "Bootstrap", "Flutter"],
    images: [
      "/images/projects/20.png",
      "/images/projects/20-2.png",
      "/images/projects/20-3.png",
      "/images/projects/20-4.png",
      "/images/projects/20-5.png",
      "/images/projects/20-6.png",
      "/images/projects/20-7.png",
    ],
    thumb: "/images/projects/20.png",
    link: "http://si-pental.com/",
    title: "SI PENTAL",
  },
  {
    categories: ["Laravel", "Bootstrap"],
    images: ["/images/projects/21.png", "/images/projects/21-2.png", "/images/projects/21-3.png", "/images/projects/21-4.png"],
    thumb: "/images/projects/21.png",
    link: "http://jurnal.avinto.my.id/",
    title: "Rumah Jurnal",
  },
];

// Auto-generate filter dari data (boleh diganti hard-code kalau mau)
const FILTERS = ["all", ...Array.from(
  new Set(GALLERY.flatMap(p => p.categories))
)];

const ProjectsSection = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewCategories, setPreviewCategories] = useState([]); // array
  const [previewImages, setPreviewImages] = useState([]);
  const [previewLink, setPreviewLink] = useState("");
  const [slide, setSlide] = useState(0);

  // Lock body scroll saat modal terbuka
  useEffect(() => {
    document.body.style.overflow = isPreviewOpen ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [isPreviewOpen]);

  // Tutup modal pakai ESC + navigasi arrow
  useEffect(() => {
    const onKey = (e) => {
      if (!isPreviewOpen) return;
      if (e.key === "Escape") setIsPreviewOpen(false);
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isPreviewOpen, previewImages, slide]);

  const openPreview = useCallback((project, startIndex = 0) => {
    setPreviewCategories(project.categories || []);
    setPreviewImages(project.images || []);
    setPreviewLink(project.link || "#");
    setSlide(startIndex);
    setIsPreviewOpen(true);
  }, []);

  const closePreview = () => setIsPreviewOpen(false);
  const next = () => setSlide((s) => (s + 1) % previewImages.length);
  const prev = () => setSlide((s) => (s - 1 + previewImages.length) % previewImages.length);

  // tampilkan item jika filter 'all' atau categories mengandung activeFilter
  const isShown = (cats) => activeFilter === "all" || cats.includes(activeFilter);

  return (
    <section className="gallery">
      <div id="project" className="shape-2 wow fadeInRightBig" data-wow-duration="1s" data-wow-delay="1s">
        <img src="/images/brush-3.png" alt="" />
      </div>

      <div className="col-lg-12 pb-20">
        <div className="section-title text-center pb-25 wow fadeInRightBig" data-wow-duration="1s" data-wow-delay="1.5s">
          <h3 className="title pb-10">My Projects</h3>
          <p>These are projects I have completed using various technologies</p>
        </div>
      </div>

      <div className="wrapper">
        {/* FILTER */}
        <div className="filter">
          <div
            className="items"
            onClick={(e) => {
              const filterName = e.target.getAttribute("data-name");
              if (filterName) setActiveFilter(filterName);
            }}
          >
            {FILTERS.map((f) => (
              <span
                key={f}
                className={`item ${activeFilter === f ? "active" : ""}`}
                data-name={f}
              >
                {f === "all" ? "All" : f}
              </span>
            ))}
          </div>
        </div>

        {/* GRID */}
        <div className="gallery">
          {GALLERY.map((item, idx) => (
            <div
              key={`${item.title || item.thumb}-${idx}`}
              className={`image ${isShown(item.categories) ? "show" : "hide"}`}
              data-name={item.categories.join(",")}
              onClick={() => openPreview(item, 0)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && openPreview(item, 0)}
              style={{ position: "relative" }}
            >
              <span>
                <img src={item.thumb} alt={item.title || "project"} />
              </span>

              {/* badges kategori (opsional) */}
              <div
                className="badges"
                style={{ position: "absolute", bottom: 8, left: 8, display: "flex", gap: 6, flexWrap: "wrap" }}
              >
                {item.categories.map((c) => (
                  <span
                    key={c}
                    className="badge"
                    style={{
                      fontSize: 12,
                      padding: "2px 8px",
                      borderRadius: 9999,
                      background: "rgba(0,0,0,0.6)",
                      color: "#fff",
                    }}
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MODAL PREVIEW (Carousel) */}
      {isPreviewOpen && (
        <>
          <div className="preview-box show" role="dialog" aria-modal="true">
            <div className="details" style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <span className="title" style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <strong>Project Categories:</strong>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {previewCategories.map((c) => (
                    <span
                      key={c}
                      className="badge"
                      style={{
                        fontSize: 12,
                        padding: "2px 8px",
                        borderRadius: 9999,
                        background: "#eef2ff",
                        color: "#1e3a8a",
                      }}
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </span>

              {previewLink && (
                <a
                  href={previewLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                  style={{ marginLeft: "auto", color: "#0d6efd", whiteSpace: "nowrap" }}
                >
                  {previewLink.replace(/^https?:\/\//, "")}
                </a>
              )}

              <span className="icon-close" onClick={closePreview} role="button" tabIndex={0}>
                <i className="bi bi-x"></i>
              </span>
            </div>

            {/* Carousel wrapper */}
            <div className="image-box" style={{ position: "relative" }}>
              <img
                src={previewImages[slide]}
                alt={`slide ${slide + 1}`}
                style={{ width: "100%", height: "auto", display: "block" }}
              />

              {previewImages.length > 1 && (
                <>
                  <button
                    aria-label="Previous"
                    onClick={prev}
                    className="carousel-prev"
                    style={{
                      position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)",
                      background: "rgba(0,0,0,0.5)", color: "#fff", border: "none",
                      padding: "8px 12px", borderRadius: 999, cursor: "pointer",
                    }}
                  >
                    ‹
                  </button>
                  <button
                    aria-label="Next"
                    onClick={next}
                    className="carousel-next"
                    style={{
                      position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
                      background: "rgba(0,0,0,0.5)", color: "#fff", border: "none",
                      padding: "8px 12px", borderRadius: 999, cursor: "pointer",
                    }}
                  >
                    ›
                  </button>

                  <div
                    className="carousel-dots"
                    style={{
                      position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)",
                      display: "flex", gap: 8,
                    }}
                  >
                    {previewImages.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setSlide(i)}
                        aria-label={`Go to slide ${i + 1}`}
                        style={{
                          width: 10, height: 10, borderRadius: "50%",
                          border: "none",
                          background: i === slide ? "#fff" : "rgba(255,255,255,0.5)",
                          cursor: "pointer",
                        }}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="shadow show" onClick={closePreview}></div>
        </>
      )}
    </section>
  );
};

export default ProjectsSection;
